import { render, staticRenderFns } from "./GalleryTitle.vue?vue&type=template&id=fb3d0f06&"
import script from "./GalleryTitle.vue?vue&type=script&lang=js&"
export * from "./GalleryTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports